import PropTypes from 'prop-types';
import React from 'react';

import Tags from '../../atoms/tags/tags';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import StyledTagList from './tagList.style';

const TagList = ({ tags, headline, breadcrumbLinks, ...props }) => {
  const listLink = breadcrumbLinks ? breadcrumbLinks.filter(link => link.type === 'listPage') : [];

  return tags.length && listLink.length > 0 ? (
    <StyledTagList {...props}>
      <Container>
        <div className="tagList__wrapper">
          {headline && <Headline className="tagList__headline">{headline}</Headline>}
          <Tags listSlug={listLink && listLink.length > 0 ? listLink[0].slug : null} tags={tags} />
        </div>
      </Container>
    </StyledTagList>
  ) : null;
};

TagList.propTypes = {
  headline: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      slug: PropTypes.string
    })
  )
};

export default TagList;
